import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-100993bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "howitworks-block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ion-text-center" }, "How it works", -1))
const _hoisted_3 = { class: "get-buttons" }
const _hoisted_4 = { class: "d-flex flex-direction-column align-items-start" }
const _hoisted_5 = { class: "d-flex flex-direction-column align-items-start" }
const _hoisted_6 = { class: "grid-container" }
const _hoisted_7 = { class: "grid-one" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/step1.png",
    alt: "",
    class: "icon"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step-teaser" }, "STEP 1/4"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "Create your profile"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-intro" }, " Register on the platform by filling a personal bio data form. Telling us about yourself. Create your profile in seconds. ")
], -1))
const _hoisted_10 = { class: "grid-two" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step-teaser" }, "STEP 2/4"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "Match with trainer"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-intro" }, " With the help of the data collected from you, we will help match you with trainers that wherever you are ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/step2.png",
    alt: "",
    class: "icon"
  })
], -1))
const _hoisted_13 = { class: "grid-three" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/step3.png",
    alt: "",
    class: "icon"
  })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step-teaser" }, "STEP 3/4"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "Pay"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-intro" }, " Securely book, pay and communicate in app with Stripe payment gateway ")
], -1))
const _hoisted_16 = { class: "grid-four" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step-teaser" }, "STEP 4/4"),
  /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "Get your sweat on, do it again.")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/step4.png",
    alt: "",
    class: "icon"
  })
], -1))

import { IonPage, IonGrid } from "@ionic/vue";
import ModalVideo from "@/general/components/modals/general/ModalVideo.vue"
import StaticMenu from "@/landing/components/landing/StaticMenu.vue";
import LandingHeader from "@/landing/components/landing/LandingHeader.vue";
import LandingFooterStatic from "@/landing/components/landing/LandingFooterStatic.vue";
import { ref } from "vue";

const videoIdTrainer = 'h9URNDgpMQs';
const videoIdClient = 'ecwJITxWd7o';

export default /*#__PURE__*/_defineComponent({
  __name: 'HowItWorks',
  setup(__props) {

const videoTrainerIsOpen = ref<boolean>(false);
const videoClientIsOpen = ref<boolean>(false);

let videoId = videoIdTrainer;

const showVideo = (type: string) => {
  if (type === 'client') {
    videoId = videoIdClient;
  } else if (type === 'trainer') {
    videoId = videoIdTrainer;
  }
  videoTrainerIsOpen.value = !videoTrainerIsOpen.value;
}


return (_ctx: any,_cache: any) => {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(StaticMenu),
    _createVNode(_unref(IonPage), {
      class: "howitworks-page",
      id: "landing-page"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonGrid), { fixed: true }, {
          default: _withCtx(() => [
            _createVNode(LandingHeader)
          ]),
          _: 1
        }),
        _createVNode(_unref(IonGrid), { fixed: true }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_ion_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showVideo('client'))),
                  class: "get-button"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_ion_text, { class: "get-button__text" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Client")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showVideo('trainer'))),
                  class: "get-button"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_ion_text, { class: "get-button__text" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Trainer & Gym")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(ModalVideo, {
              videoId: _unref(videoId),
              isOpen: videoTrainerIsOpen.value,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (videoTrainerIsOpen.value = false))
            }, null, 8, ["videoId", "isOpen"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(IonGrid), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          size: "12",
                          "size-lg": "6"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          size: "12",
                          "size-lg": "6"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(IonGrid), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          size: "12",
                          "size-lg": "6"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          size: "12",
                          "size-lg": "6"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(IonGrid), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          size: "12",
                          "size-lg": "6"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          size: "12",
                          "size-lg": "6"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(IonGrid), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          size: "12",
                          "size-lg": "6"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          size: "12",
                          "size-lg": "6"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(LandingFooterStatic)
      ]),
      _: 1
    })
  ], 64))
}
}

})